import { OrganizationGroupSummaryDTO } from '@reposit/api-client';
import React, { Fragment, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import Button from '../../../components/Button';
import ConfirmationModal from '../../../components/ConfirmationModal';
import IdentifierValue from '../../../components/IdentifierValue';
import { Td, Tr } from '../../../components/Table';
import { createLoadingSelector } from '../../../redux/loading/loading.selector';
import {
  DELETE_ORG_GROUP_STORE_KEY,
  deleteOrganizationGroupRequested,
} from '../../../redux/organization-group/organization-group-management.actions';

interface UnusedOrganizationGroupRowProps {
  organizationGroup: OrganizationGroupSummaryDTO;
}

const ActionsCell = styled(Td)`
  text-align: right;
`;

const UnusedOrganizationGroupRow: React.FC<UnusedOrganizationGroupRowProps> = ({ organizationGroup }) => {
  const dispatch = useDispatch();
  const isDeleting = useSelector(createLoadingSelector([DELETE_ORG_GROUP_STORE_KEY]));
  const [isConfirmingDeletion, setIsConfirmingDeletion] = useState(false);

  const confirmDeletion = useCallback(() => {
    if (isDeleting) return;

    dispatch(deleteOrganizationGroupRequested({ id: organizationGroup.id }));
  }, [dispatch, isDeleting, organizationGroup.id]);

  const dismissDeletion = useCallback(() => {
    if (isDeleting) return;

    setIsConfirmingDeletion(false);
  }, [isDeleting]);

  return (
    <Fragment>
      <Tr>
        <Td>{organizationGroup.name}</Td>
        <Td>
          <IdentifierValue>{organizationGroup.id}</IdentifierValue>
        </Td>
        <ActionsCell>
          <Button type="button" buttonType="warning" noArrow={true} onClick={() => setIsConfirmingDeletion(true)}>
            Delete
          </Button>
        </ActionsCell>
      </Tr>
      {isConfirmingDeletion ? (
        <ConfirmationModal
          title="Delete Parent/Ultimate Parent?"
          text={
            <>
              Delete {organizationGroup.name} (<IdentifierValue>{organizationGroup.id}</IdentifierValue>)? This cannot be undone.
            </>
          }
          loadingActions={[DELETE_ORG_GROUP_STORE_KEY]}
          onDismiss={dismissDeletion}
          onSubmit={confirmDeletion}
        />
      ) : null}
    </Fragment>
  );
};

export default UnusedOrganizationGroupRow;
